import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const dependentDataState = atom({
  key: "dependentDataState",
  default: [],
  effects_UNSTABLE: [ocPersistAtom],
});
